export default "__VITE_ASSET__CkDzW53Y__"